import { getRangeFromToLabel } from '@/bundles/GroupFilters/helpers/formatters/range/getRangeFromToLabel';
import { formatCurrencyShowDecimalWhenExist } from '@/utils/filters';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { Nullable } from '@/utils/types';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';

export const getCurrencyRangeFormattedValue = (value: [Nullable<string | number>, Nullable<string | number>], configFilter?: IFilterConfigItem): string => {
  const isValuePresentInArray = value.some((v) => isValuePresent(v));
  return isValuePresentInArray ? getRangeFromToLabel(value.map((v) => {
    if (!isValuePresent(v)) {
      return null;
    }

    return configFilter?.formatter ? configFilter.formatter(v) : formatCurrencyShowDecimalWhenExist(v);
  })) : ''
}
